export default __webpack_public_path__ + "static/media/infoIcon.e2e68c4d.svg";